import { render } from "./Editocean.vue?vue&type=template&id=6b460646"
import script from "./Editocean.vue?vue&type=script&lang=js"
export * from "./Editocean.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__